























































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import Employee from '@/models/Employee';
import ContactInfo from '@/models/ContactInfo';
import User from '@/models/User';
import { TimeSlot } from '@/models/Time';
import { EventBus } from '@/event-bus';
import moment from 'moment';
import _ from 'lodash';

@Component
export default class EmployeeSchedule extends Vue {
  @Getter
  currentUser: User;
  availableTimeSlots = {};
  items = { a: [{ name: 1 }, { name: 2 }, { name: 3 }] };
  date = new Date().toISOString().substr(0, 10);
  time = null;
  startTime = null;
  endTime = null;
  dateMenu = false;
  timeMenu = false;
  startTimeMenu = false;
  endTimeMenu = false;
  formMode = false;
  validForm = false;
  loading = false;
  dateRules = [v => !!v || 'Date is required'];
  startTimeRules = [];
  endTimeRules = [];
  todayDate = moment();

  created() {
    (async () => {
      this.availableTimeSlots = await this.$store.dispatch('getAvailableTimeSlot');
      this.startTimeRules = [
        v => !!v || 'Start time is required',
        v => {
          if (!this.endTime) {
            return true;
          }
          return v < this.endTime || 'Start time has to be at an earlier time';
        },
        v =>
          !this.isOverlapped(this.availableTimeSlots, {
            date: this.date,
            startTime: this.startTime,
            endTime: this.endTime
          }) || 'This slot overlapped with an existing time slot'
      ];
      this.endTimeRules = [
        v => !!v || 'End time is required',
        v => {
          if (!this.startTime) {
            return 'Start time is blank';
          }
          return v > this.startTime || 'End time has to be at a later time';
        },
        v =>
          !this.isOverlapped(this.availableTimeSlots, {
            date: this.date,
            startTime: this.startTime,
            endTime: this.endTime
          }) || 'This slot overlapped with an existing time slot'
      ];
    })();
  }

  showForm() {
    this.formMode = true;
  }

  back() {
    this.$router.back();
  }

  reset() {
    this.formMode = false;
    this.time = null;
    this.endTime = null;
    this.startTime = null;
    this.date = this.todayDate.format('YYYY-MM-DD');
  }

  isValid() {
    return this.validForm && !this.loading;
  }

  submit() {
    if (this.validateForm()) {
      const timeSlot = { startTime: this.startTime, endTime: this.endTime };
      const timeSlots = this.availableTimeSlots[this.date].slots || [];
      timeSlots.push(timeSlot);
      timeSlots.sort((a, b) => (a.startTime < b.startTime ? -1 : a.startTime > b.startTime ? 1 : 0));
      EventBus.$emit('loading', 'submitting');
      this.$store.dispatch('addAvailableTimeSlot', { date: this.date, slots: timeSlots }).then(res => {
        EventBus.$emit('loaded');
      });
    }
  }

  changeStartTime() {
    (this.$refs.startTimeMenuRef as any).save(this.startTime);
    if (this.endTime) {
      // only validate if the time is not empty
      this.validateForm();
    }
  }

  changeEndTime() {
    (this.$refs.endTimeMenuRef as any).save(this.endTime);
    if (this.startTime) {
      // only validate if the time is not empty
      this.validateForm();
    }
  }
  changeDate(d) {
    this.dateMenu = false;
  }

  isOverlapped(timeSlots, timeSlot) {
    timeSlots[this.date] = timeSlots[this.date] || {};
    timeSlots = timeSlots[this.date].slots || [];
    if (timeSlot.startTime && timeSlot.endTime) {
      const daySlots: any = _.map(timeSlots, _.clone);
      daySlots.push(timeSlot);
      daySlots.sort((a, b) => (a.startTime < b.startTime ? -1 : a.startTime > b.startTime ? 1 : 0));
      for (let i = 1; i < daySlots.length; i++) {
        if (daySlots[i - 1].endTime > daySlots[i].startTime) {
          return true;
        }
      }
    }
    return false;
  }

  validateForm() {
    return (this.$refs.form as any).validate();
  }

  deleteTimeSlot(slot) {
    this.loading = true;
    this.$store.dispatch('deleteAvailableTimeSlot', { date: this.date, slot }).then(res => {
      this.loading = false;
    });
  }

  allowedDates(v) {
    const minDate = moment().format('YYYY-MM-DD');
    const maxDate = moment()
      .add(14, 'days')
      .format('YYYY-MM-DD');
    if (v >= minDate && v <= maxDate) {
      return true;
    }
  }
}
